//新手引导
import Driver from 'driver.js' // import driver.js
import 'driver.js/dist/driver.min.css' // import driver.js css
import loginvuex from "@/store/index";
import $guide from "@/api/guide";
//全局公共方法
const commonUtils = {
  resetForm:function (formName,obj,that) {
    //清空表单
    if(that.$refs[formName]){
      that.$refs[formName].resetFields();
    }
    //清空数据域
    Object.keys(obj).forEach(key =>{
      obj[key] = '';
    })
  },
  getHMS:function (resultVal) {
    const hour = parseInt(resultVal / 3600) < 10 ? '0' + parseInt(resultVal / 3600) : parseInt(resultVal / 3600);
    const min = parseInt(resultVal % 3600 / 60) < 10 ? '0' + parseInt(resultVal % 3600 / 60) : parseInt(resultVal % 3600 / 60);
    const sec = parseInt(resultVal % 3600 % 60) < 10 ? '0' + parseInt(resultVal % 3600 % 60) : parseInt(resultVal % 3600 % 60);
    return hour + '时' + min + '分' + sec + '秒'
  },
  getSourceCn:function (resultVal) {
    switch (resultVal) {
      case "H5":
        return "H5";
      case "new_xxy_andriod":
        return "安卓";
      case "new_xxy_ios":
        return "IOS";
    }
  },
  //新手引导功能begin
  getGuideDriver:function () {
    return new Driver({
      allowClose: false,
      onDeselected: (Element)=>{
        this.insertUserGuideLog('#'+Element.node.id);
      },
    });
  },
  initGuideDriver:function (driver,guideSteps) {
    if(guideSteps.length > 0){
      driver.defineSteps(guideSteps);
      driver.start();
      //点击高亮时
      let allSteps = driver.steps;
      allSteps.forEach(res =>{
        res.node.addEventListener('click',(e)=>{
          if(driver.isActivated){
            if(driver.hasNextStep()){
              driver.moveNext();
            }else{
              driver.reset("11111");
            }
          }
        });
      });
    }
  },
  getUserGuideList:async function (pageCode) {
    let parmas = {
      userID: JSON.parse(loginvuex.state.userlist).userID,
      guid: JSON.parse(loginvuex.state.userlist).guid,
      pageCode:pageCode
    };
    const res = await $guide.getUserGuideList(parmas);
    if (res.data.Status === 200) {
      return res.data.Data;
    }else{
      return [];
    }
  },
  insertUserGuideLog:async function (element) {
    let parmas = {
      userID: JSON.parse(loginvuex.state.userlist).userID,
      guid: JSON.parse(loginvuex.state.userlist).guid,
      element:element
    };
    $guide.insertUserGuideLog(parmas);
  }
  //新手引导功能end
};

export default commonUtils;
